export default "__VITE_ASSET__CBNw8b$Z__"